import React from "react";
import { WhiteContainer } from "../../../../../styles/orderform.tsx"
import AlertTriangle from "../../../../../assets/images/icon-alert-triangle.svg";

function ErrorWrapper({ showError, children }: { showError: boolean, children: React.ReactNode }) {
  return (
    <div style={{ position: 'relative', marginTop: showError ? '20px' : '0' }}>
      {showError && <img src={AlertTriangle} className="alert-icon" />}
      {/* <WhiteContainer id={id} className={showError ? 'error' : ''}> */}
        {children}
      {/* </WhiteContainer> */}
    </div>
  );
}

export default ErrorWrapper;
